//独立图片上传
import IMAGEAPI_TYPE from "@/constants/imageApiType";
import { logger } from "@/utils/logger";
import { getImageApiPath } from "@/utils/multiSite";
import { MONITOR_CODE_TYPE } from "@/utils/sgmUtils";

// 正式环境图片上传域名配置
const PRODUCTION_APICONFIG = {
  [IMAGEAPI_TYPE.PersonalInfo]: "/30/ee9bb0ac5466436dafac2445572c1d1e",
  [IMAGEAPI_TYPE.Reviews]: "/30/9ad51062a80047e38782da4234a88eaa",
  [IMAGEAPI_TYPE.FeedBack]: "/30/ddd2b2becd00430ea1ef58999d8bf15c",
  [IMAGEAPI_TYPE.AfterSale]: "/30/2597085c4e7e4dba88d004fa9234793c",
}

// 测试环境图片上传域名配置
const DEVELOPMENT_APICONFIG = {
  [IMAGEAPI_TYPE.PersonalInfo]: "/30/af6dc2ddc49e46feabf0a00de353004f",
  [IMAGEAPI_TYPE.Reviews]: "/30/a5d59408dd104777a769b858e979d16b",
  [IMAGEAPI_TYPE.FeedBack]: "/30/112a799aa0ff4372a4b570966a896980",
  [IMAGEAPI_TYPE.AfterSale]: "/30/4077376e156641d6a0c9f5fc06477148",
}

const API_URLS = (process.env.NEXT_PUBLIC_APP_ENV === "development" || process.env.NEXT_PUBLIC_APP_ENV === "test") ? DEVELOPMENT_APICONFIG : PRODUCTION_APICONFIG;

export const imageUploadApi = async (file: any, type: IMAGEAPI_TYPE = IMAGEAPI_TYPE.PersonalInfo) => {
  const formdata = new FormData();
  formdata.append("file", file);
  formdata.append("common", '{"client":"pc","forceLoginType":30}');
  const apiPath = getImageApiPath();
  const imageUrl = apiPath + API_URLS[type];
  logger.info({
    eventName: MONITOR_CODE_TYPE.API_REQ,
    msg: {
      type,
      imageUrl,
      fileName: file?.name || ""
    },
  });
  return fetch(imageUrl, {
    method: "POST",
    body: formdata,
    credentials: "include",
    redirect: "follow",
  })
    .then((response) => response.json())
    .then((result) => {
      if (result && result.id === '1') {
        logger.info({
          eventName: MONITOR_CODE_TYPE.API_SUCCESS,
          msg: { imageUrl, imageIcon: result.msg, msg: result.msgDetails },
        });
      }
      else {
        logger.error({
          eventName: MONITOR_CODE_TYPE.API_FAILED,
          msg: { imageUrl, imageIcon: result?.msg, msg: result?.msgDetails },
        });
      }
      return result;
    })
    .catch((error: any) => {
      console.log(error);
      logger.error({
        eventName: MONITOR_CODE_TYPE.FETCH_FAILED,
        msg: { imageUrl, error: error?.message },
      });
    });
};
